import CMSService from "services/CMS";
import AddressService from "services/Address";
import AddressFactory from "factories/Address";
import StorageService from 'services/StorageService';
import TagManagerService from 'services/TagManager';
import { balancerWL } from 'config'
import { ecommerce, defaultSC } from 'config/constants';

const submit = (tab, storeSelected, addressSelected, scrollerAddress, scrollerStore, stores) => {
    let method = "seller-1-sla-DespachoaDomicilio";
    let name = '';
    let sc = 11;
    let nameMethod  = '';
    let selectedAddress = '';
    let notScMessage = false;

    return new Promise((resolve, reject) => {

        let sellerId = null;
        let coordinates = [];
        
        if(tab){

            if(ecommerce.whiteLabel) {
                sellerId = storeSelected.seller;
                coordinates = storeSelected && storeSelected.coordinates && storeSelected.coordinates.split(',').map((item) => item * 1).reverse();
            }

            switch(storeSelected.method){
                case 'store':
                    method = "seller-1-sla-RetiroenTienda";
                    name = storeSelected.value;
                    sc = storeSelected.sc;
                    TagManagerService.changeDeliveryMode('retiro en local: ' + name);
                    nameMethod = 'Retiro en Tienda';
                    break;

                case 'auto':
                    method = "seller-1-sla-ClickalAuto";
                    name = storeSelected.value;
                    sc = storeSelected.sc;
                    TagManagerService.changeDeliveryMode('retiro en auto: ' + name);
                    nameMethod = 'Click al Auto';
                    break;
            }
        } else {
            if(addressSelected && addressSelected.value){
                selectedAddress = addressSelected.value;
                name = selectedAddress.neighborhood;
                TagManagerService.receiveHome(selectedAddress.street + ' ' + '' + selectedAddress.number + ' ' + '' + selectedAddress.neighborhood + ' ' + '' + selectedAddress.city + ' ' + '' + selectedAddress.state);
                nameMethod = 'Despacho a Domicilio';
            }
        }

        if(ecommerce.whiteLabel){
            sc = defaultSC;
            DeliveryWhitelabelSumit(tab, addressSelected, scrollerAddress, scrollerStore, notScMessage, resolve, reject, coordinates, sellerId, method, sc, name, nameMethod, selectedAddress, stores);
        }else{
            DeliverySubmit(tab, addressSelected, scrollerAddress, scrollerStore, notScMessage, resolve, reject, method, sc, name, nameMethod, selectedAddress);
        }
    })
}

const DeliveryWhitelabelSumit = (tab, addressSelected, scrollerAddress, scrollerStore, notScMessage, resolve, reject, coordinates, sellerId, method, sc, name, nameMethod, selectedAddress, stores) => {

    if(!tab){
        if(scrollerAddress){
            scrollerAddress.current.scrollTo({top: 0, behavior: 'smooth'});
        }
        if(addressSelected && selectedAddress.geoCoordinate){
            AddressService.getSeller(selectedAddress.geoCoordinate[1], selectedAddress.geoCoordinate[0]).then((response) => {
                selectedAddress.geoCoordinates = selectedAddress.geoCoordinate;
                if(response && response.warehouseId){
                    let sellerID = null
                    if(balancerWL?.status){
                        sellerID = response.seller 
                    }else{
                        let sellerSelected = stores ? stores.filter(store => store.warehouse_id === response.warehouseId) : null;
                        if(sellerSelected && sellerSelected.length){
                            sellerID = sellerSelected[0].seller;
                        }
                    }
                    if(sellerID){
                        return _applyDelivery(sc, method, name, nameMethod, selectedAddress, true, sellerID).then(response => {
                            response.notScMessage = response.notDisponibleMessage || notScMessage;
                            resolve(response);
                        })
                    }
                }else{
                    notScMessage = true;
                    
                    resolve({
                        notScMessage
                    })
                }
            }).catch(err => {
                reject(err);
            })
        }
    }else{
        if(scrollerStore){
            scrollerStore.current.scrollTo({top: 0, behavior: 'smooth'});
        }
        _applyDelivery(sc, method, name, nameMethod, false, true, sellerId, coordinates).then(response => {
            response.notScMessage = notScMessage
            resolve(response);
        })
    }

}

const DeliverySubmit = (tab, addressSelected, scrollerAddress, scrollerStore, notScMessage, resolve, reject, method, sc, name, nameMethod, selectedAddress) => {

    if(!tab){
        if(scrollerAddress){
            scrollerAddress.current.scrollTo({top: 0, behavior: 'smooth'});
        }

        if(addressSelected && selectedAddress.geoCoordinate){
            AddressService.getSalesChannel(selectedAddress.geoCoordinate[1], selectedAddress.geoCoordinate[0]).then(salesChannel => {
                if (salesChannel.sc) {
                    sc = salesChannel.sc;
                    selectedAddress.geoCoordinates = selectedAddress.geoCoordinate;
                    return _applyDelivery(sc, method, name, nameMethod, selectedAddress).then(response => {
                        response.notScMessage = response.notDisponibleMessage || notScMessage;
                        resolve(response);
                    })
                } else {
                    notScMessage = true;

                    resolve({
                        notScMessage
                    })
                }
            }).catch(err => {
                reject(err);
            })
        }
    }else{
        if(scrollerStore){
            scrollerStore.current.scrollTo({top: 0, behavior: 'smooth'});
        }

        _applyDelivery(sc, method, name, nameMethod, false).then(response => {
            response.notScMessage = notScMessage
            resolve(response);
        })
    }

}


const _applyDelivery = (sc, method, name, nameMethod, selectedAddress = null, simulation = true, sellerId = null, coordinates = null, applyShipping = false, includeOrderForm = false) =>{

    const responsePromise = {
        data: {
            isDisponible: true
        }
    }

    let notDisponibleMessage = false;

    let consult = simulation ? AddressService.getLogisticSimulation(selectedAddress, sc, nameMethod, sellerId, coordinates) : Promise.resolve(responsePromise);

    return consult.then(data => {

        if(data.data && data.data.isDisponible){
            return AddressService.newSetDeliveryMode(method, name, sc, true, selectedAddress, true, applyShipping, sellerId, coordinates).then((result)=>{
                if(!result){
                    return {
                        error: true
                    }
                }

                return {
                    close: true,
                    orderForm: includeOrderForm ? result : null
                }
            });
        } else {
            notDisponibleMessage = true;

            return {
                notDisponibleMessage
            }
        }
    })

}

const blockedStore = (stores, storeSelected) => {
    return stores ? stores.map((store) => {

        if(storeSelected && (store.name == storeSelected.name)){
            store.disabled = true;
        }

        return store
    }) : [];
}

const blockedAddress = (addresses, addressSelected) => {
    return addresses ? addresses.map((address) => {

        if((addressSelected && addressSelected.value) && (address.value.addressId == addressSelected.value.addressId)){
            address.disabled = true;
        }

        return address;
    }) : [];
}

const getAddress = (token) => {
    if (token) {
        return AddressService.getAll(token).then(adresses => {
            let listAddress = AddressFactory.getAdressesOptions(adresses);
            const address = _getAddressDefault();
            const deliveryType = _getDeliveryType(AddressService.getDeliveryMode());
            let selectedAddress = null;

            if(address && (deliveryType === 0 || deliveryType === 3)){
                listAddress = listAddress && listAddress.map((add) => {
                    if(add.value.addressId == address.value.addressId) return false;
                    add.saved = false;
                    return add;
                }).filter(Boolean);

                address.saved = true;
                listAddress = new Array(address).concat(listAddress);
                selectedAddress = address;

            }

            return {
                selectedAddress,
                listAddress
            }
        })
    } else {
        const adresses = AddressService.getAnonymousAdresses();
        if (adresses) {
            return  Promise.resolve({
                listAddress: AddressFactory.getAdressesOptions(adresses)
            })
        }

        return Promise.resolve({});
    }
}

const _getAddressDefault = () => {
    const address = StorageService.getSecureItem('address');

    if(address){
        delete address.geoCoordinates;
        const objAddress = AddressFactory.getAdressesOptions([address])[0];
        return objAddress;
    }
    else{
        return null;
    }
}

const _getDeliveryType = (type, text = false) => {
    switch (type) {
        case "seller-1-sla-ClickalAuto":
            return text ? 'auto' : 2

        case 'seller-1-sla-RetiroenTienda':
            return text ? 'store' : 1

        case 'seller-1-sla-DespachoaDomicilio':
            return text ? 'home' : 0

        case "Jumbo Chile":
            return text ? 'home' : 3

        case 'seller-1-sla-Express':
            return text ? 'express' : 3
        default:
            StorageService.setItem('store_name', 'Jumbo Chile');
            return  0
    }
}

const getCurrent = () => {
    let firstSelection = {};

    const deliveryType = _getDeliveryType(AddressService.getDeliveryMode());
    const deliveryTypeText = _getDeliveryType(AddressService.getDeliveryMode(), true);
    const storeName = StorageService.getItem('store_name');

    let tab = false;
    let selectedAddress = null;

    if(deliveryType === 0 || deliveryType === 3){

        selectedAddress = _getAddressDefault();

    } else if (deliveryType === 1 || deliveryType === 2){
        tab = true;
        firstSelection = {
            name: storeName,
            method: deliveryTypeText
        }
    }

    return CMSService.getOperationsV2().then(data => {
        if (!data) {
            data = {};
        }
        let newStoreSelected = data.store.filter((store) => store.name === firstSelection.name)[0];

        let st = data.store ? data.store.filter(store => store.active) : [];
        if(newStoreSelected && firstSelection.name){
            newStoreSelected.method = firstSelection.method;
            st = st.map((store) => {
                if(store.value == newStoreSelected.value) return false;
                store.saved = false;
                return store;
            }).filter(Boolean);

            newStoreSelected.saved = true;
            st = new Array(newStoreSelected).concat(st);
        }

        return {
            tab,
            selectedAddress,
            newStoreSelected,
            stores: [...st]
        }
    });
}

const DeliverySelectorService = {
    submit,
    blockedStore,
    blockedAddress,
    getAddress,
    getCurrent,
    _applyDelivery
}

export default DeliverySelectorService;
